import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useStyles } from './style';
import ActionCTA from '../sweepr-action-cta/ActionCTA';

/**
 * @name ActionCTA - Generic Error component for sweepr widget
 * @param {Array} props - React props
 * @returns {JSX.Element} - Error component
 */
const HandleError = props => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <Box>
      <Typography variant='h3'>{props?.title}</Typography>
      <Typography variant='body1'>{props?.description}</Typography>
      <Box sx={style.ctaContainer}>
        <ActionCTA cta={props?.cta} handleAction={props.handleAction} errorCTA />
      </Box>
    </Box>
  );
};

HandleError.displayName = 'HandleError';
export default HandleError;
